import axios from 'axios';

// Base URL: priorité à REACT_APP_API_URL, sinon même origine (utile sur Vercel/production)
const RAW_BASE_URL = (process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? window.location.origin : '')).trim();
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, ''); // retire les trailing slashes
const API_URL = `${BASE_URL}/api/orders`;

export const createOrder = async (orderData) => {
    try {
        const response = await axios.post(API_URL, orderData);
        return response.data;
    } catch (error) {
        throw new Error('Error creating order: ' + error.message);
    }
};

export const getPricing = async () => {
    try {
        const response = await axios.get(`${API_URL}/pricing`);
        return response.data;
    } catch (error) {
        throw new Error('Error fetching pricing: ' + error.message);
    }
};

export const getOrders = async (token) => {
    try {
        const response = await axios.get(`${API_URL}` , {
            headers: token ? { 'Authorization': `Bearer ${token}` } : {}
        });
        return response.data;
    } catch (error) {
        throw new Error('Error fetching orders: ' + error.message);
    }
};